<div class="flex flex-col h-full">

  <div mat-dialog-title class="flex flex-row items-center
                               pt-6 pl-6 pr-6 pb-4 m-[unset]">
    <div class="flex flex-row justify-center items-center
                      w-[40px] h-[40px] rounded-lg
                      bg-green-90">
      <mat-icon svgIcon="cookie" class="text-neutral-10 w-[26px] h-[26px]"></mat-icon>
    </div>
    <span
        class="ml-4 text-neutral-10 text-headline-small">{{ 'CONSENT.POPUP_TITLE' | translate }}</span>
  </div>

  <mat-dialog-content class="m-[unset] pb-[24px] flex flex-col">
    <span class="pb-6">
      <span>{{ ('CONSENT.POPUP_MAIN_TEXT' | translate) + ' ' }}</span>
      <a href="https://www.g-xperts.net/imprint-privacy-policy"
         target="_blank">
        <span>{{ 'CONSENT.POPUP_PRIVACY_POLICY' | translate }}</span>
        <mat-icon svgIcon="open_in_new"
                  class="align-middle w-[18px] h-[18px] text-green-10 pl-1"></mat-icon>
      </a>
    </span>

    <mat-slide-toggle disabled
                      [checked]="essential"
                      class="pb-3"
                      color="primary">
      <span
          class="pl-3 text-neutral-10 text-title-medium">{{ 'CONSENT.POPUP_NECESSARY_COOKIES_LABEL' | translate }}</span>
    </mat-slide-toggle>
    <span class="pb-6">{{ 'CONSENT.POPUP_NECESSARY_COOKIES_TEXT' | translate }}</span>

    <mat-slide-toggle [(ngModel)]="analytics"
                      class="pb-3"
                      color="primary">
      <span
          class="pl-3 text-neutral-10 text-title-medium">{{ 'CONSENT.POPUP_ANALYTICS_COOKIES_LABEL' | translate }}</span>
    </mat-slide-toggle>
    <span>{{ 'CONSENT.POPUP_ANALYTICS_COOKIES_TEXT' | translate }}</span>
  </mat-dialog-content>

  <mat-dialog-actions class="justify-end min-h-[unset]
                             mb-0 pb-6 pl-6 pr-6 pt-0">
    <button matButton="outlined" mat-dialog-close tabindex="-1">{{ 'CANCEL' | translate }}</button>
    <button mat-flat-button [mat-dialog-close]="onSave()" color="primary" tabindex="-1"
            class="flex flex-row items-center justify-center"
            [disabled]="!isChange()">{{ 'SAVE' | translate }}</button>
  </mat-dialog-actions>

</div>
